import Vue from 'vue'
import settings from './settings.coffee'
import queries from './gqlQueries.coffee'

gqlDjangoMapping = {
    "notification_set":
        appLabel: "core"
        modelName: "notification"
    "state_set":
        appLabel: "state"
        modelName: "state"
    "review_set":
        appLabel: "review"
        modelName: "review"
    "review_set_paginated":
        appLabel: "review"
        modelName: "review"
    "establishment_set":
        appLabel: "establishment"
        modelName: "establishment"
    "establishment":
        appLabel: "establishment"
        modelName: "establishment"
        single: true
    "estblishment_picture_set":
        appLabel: "establishment"
        modelName: "establishmentimage"
    "connection_set":
        appLabel: "establishment"
        modelName: "connection"
    "consultant_set":
        appLabel: "consultant"
        modelName: "consultant"
    "consultant":
        appLabel: "consultant"
        modelName: "consultant"
        single: true 
    "alert_set":
        appLabel: "consultant"
        modelName: "alert"
}

query = (options)->
    p = new Promise (resolve, reject)->
        gql_query = queries.buildModelQuery(options)
        Vue.http.post(settings.graphqlApiUrl, {query: gql_query})
        .then (data)->
            resolve(data.body.data[options.model])
        .catch (data)->
            if data.body.errors?
                for err in data.body.errors
                    console.error(err.message)
            reject(data)
    return p

get = (options)->
    p = new Promise (resolve, reject)->
        gql_query = queries.buildModelGetQuery(options)
        Vue.http.post(settings.graphqlApiUrl, {query: gql_query})
        .then (data)->
            resolve(data.body.data[options.model])
        .catch (data)->
            for err in data.body.errors
                console.error(err.message)
            reject(data)
    return p


class DataHolder

    constructor: (options)->
        vm = @
        vm._isDataHolder = true
        vm.totalCount = 0
        vm.current_offset = 0
        vm.wsCallback = vm.onmodelsignals
        vm.options = options
        vm.total_count = 0
        vm.queryOnGoing = false
        
        if typeof vm.options.filters == 'object'
            vm.options.filters = vm.buildQueryFilters(vm.options.filters)
        
        if not gqlDjangoMapping[options.model]?
            console.error("Error #{options.model} is not defnied in gqlDjangoMapping")
        Vue.djangows.onmodelsignals(
            gqlDjangoMapping[options.model],
            vm.onmodelsignals(vm)
        )
        if gqlDjangoMapping[options.model].single? and gqlDjangoMapping[options.model].single
            vm.options["single"] = true
            vm.results = {}
        else
            vm.options["single"] = false
            vm.results = []
        if not options.autoload? or options.autoload
            vm.promise = vm.query()
        else
            vm.promise = new Promise (resolve, reject)->
                resolve([])
        if options.reload_on_models?
            for model in options.reload_on_models
                Vue.djangows.onmodelsignals(
                    gqlDjangoMapping[model],
                    vm.onmodelsignals(vm)
                )

    clearFilters: ()->
        this.options.filters = null

    buildQueryFilters: (filtersDict)->
        vm = @
        # filters = ""
        filters_list = []
        for key, val of filtersDict
            if val?
                if val.uid?
                    filters = "#{key}:\"#{val.uid}\" "
                else
                    if typeof val == "boolean"
                        filters = "#{key}:#{val} "
                    else if typeof val == "number"
                        filters = "#{key}:#{val} "
                    else
                        filters = "#{key}: \"#{val}\" "
                filters_list.push(filters)
        filters = filters_list.join()
        return filters

    query: (filters, next_page)->
        vm = @
        if filters?
            vm.options.filters = vm.buildQueryFilters(filters)
            vm.current_offset = 0
        if vm.options.handle_pagination? and vm.options.handle_pagination
            if vm.options.filters.indexOf('offset') >= 0
                vm.options.filters = vm.options.filters.replace(/offset\:[0-9]+/,"offset:#{vm.current_offset}")
            else
                vm.options.filters += " offset:#{vm.current_offset}"
        p = new Promise (resolve, reject)->
            # console.log("query", vm.options)
            query(vm.options).then (res)->
                if res.length > 0 and res[0].total_count
                    vm.total_count = res[0].total_count
                else
                    vm.total_count = 0
                if vm.options.single
                    vm.results = res
                else
                    vm.current_offset += res.length
                    if next_page                        
                        vm.results = vm.results.concat(res)
                    else
                        vm.results = res
                
                resolve() 

        return p

    getDataUids: ()->
        vm = @
        return vm.results.map (el)->
            return el.uid

    onmodelsignals: (vm)->
        # console.log("onmodelsignals")
        cb = (data)->
            
            is_main_model = gqlDjangoMapping[vm.options.model].appLabel == data.app and
                            gqlDjangoMapping[vm.options.model].modelName == data.model
            # console.log("onmodelsignals cb", is_main_model, vm.queryOnGoing)
            if not is_main_model
                return
                        
            if not vm.options.filters?
                vm.options.filters = ""

            options = Object.assign({}, (vm.options))
            if vm.options.pk?
                if vm.options.filters.indexOf(vm.options.pk+": \"") < 0
                    options.filters += " "+vm.options.pk+": \""+data.pk+"\" "
            else
                options.filters += " uid:\""+data.pk+"\" "

            options.filters = options.filters.replace(/offset\:[0-9]+/, " ")

            # -- add a jitter random to avoid all queries at the same time
            if vm.queryOnGoing
                return
            # -- also add a debounce
            vm.queryOnGoing = true
            jitter = Math.random()*1000
            # console.log("onmodelsignals cb jitter", jitter)
            setTimeout(()->
                # console.log("onmodelsignals cb debounced", options)
                # -- clear offset in case of update
                vm.current_offset = 0
                vm.query()
                .then (respS)->
                    vm.queryOnGoing = false
                    if vm.results.constructor == Array
                        local_uids = vm.results.map((el)->el.uid)
                    else
                        local_uids = [vm.results.uid]
                    index = local_uids.indexOf(data.pk)
                    if respS?
                        if respS.length > 0
                            if index >= 0
                                vm.results.splice(index, 1, respS[0])
                            else
                                vm.results.push(respS[0])
                        else
                            if respS.constructor == Array
                                if not data.created and index > 0
                                    vm.results.splice(index, 1)
                            else
                                vm.results = respS
                .catch ()->
                    vm.queryOnGoing = false
                    
            , jitter)

            return
        vm.cb = cb
        return cb

    load_next_page: ()->
        vm = @
        p = new Promise (resolve, reject)->
            vm.query(null, true)
            .then (res)->              
                resolve()
            .catch ()->
                reject()
        return p

export default {
    getSchema: ()->
        return Vue.http.post(settings.graphqlApiUrl, {query: queries.schemaQuery})
    query: query
    get: get
    DataHolder: DataHolder
}
